import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "reactstrap";
import SecondaryHeader from "../../../../Layouts/SecondaryHeader";
import Sidebar from "./PosSidebar";
import OrderSummary from "../../page/OrderSummary/OrderSummary";
import ProductPage from "../../page/ProductPage/ProductPage";
import ProductItemServices from "../../../../services/OrderingServices/ProductItemService";
import toast from "react-hot-toast";
import OrderServices from "../../../../services/OrderingServices/OrderServices";
import TableService from "../../../../services/OrderingServices/TableService";
import SectionService from "../../../../services/OrderingServices/SectionService";
import OrderSummaryModal from "../../page/OrderSummary/OrderSummaryMobile";
import {
  addOrderItem,
  resetOrder,
  resetTableOrder,
  setApiOrderData,
  setOrderData,
  setPlacedOrder,
  transferTempToTable,
} from "../../../../slices/Order/orderSlice";
import { useDispatch, useSelector } from "react-redux";

import RestroOrderService from "../../../../services/RestroOrder/RestroOrderService";

const PosLayout = () => {
  const dispatch = useDispatch();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [productExtrasMap, setProductExtrasMap] = useState({});
  console.log("🚀 ~ PosLayout ~ productExtrasMap:", productExtrasMap);

  const [recentCustomers, setRecentCustomers] = useState([]);
  const selectedCustomer = JSON.parse(localStorage.getItem("selectedCustomer"));

  const [selectedCourt, setSelectedCourt] = useState(() => {
    try {
      const item = localStorage.getItem("selectedCourt");
      if (!item || item === "undefined") return null;

      const parsed = JSON.parse(item);
      // Validate required fields
      if (parsed?.TableKey) {
        return parsed;
      }
      return null;
    } catch (error) {
      console.warn("Failed to parse selectedCourt from localStorage", error);
      return null;
    }
  });
  const orderData = useSelector((state) => {
    return state.order.orderData;
  });
  console.log("🚀 ~ PosLayout ~ orderData:", orderData);
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedAttributes, setSelectedAttributes] = useState([]);
  const [selectedChildAttributes, setSelectedChildAttributes] = useState([]);
  const [isTableOpen, setIsTableOpen] = useState(false);
  const [notes, setNotes] = useState("");
  const [complementary, setComplementary] = useState(false);
  const [count, setCount] = useState(1);
  const [complementaryCount, setComplimentaryCount] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isMobileOrder, setIsMobileOrder] = useState(false);
  const [billsData, setBillsData] = useState();
  const [data, setData] = useState([]);
  const [sectionData, setSectionData] = useState([]);
  const [selectedSection, setSelectedSection] = useState(null);
  console.log("🚀 ~ PosLayout ~ selectedSection:", selectedSection);
  const [orderId, setOrderId] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [itemCounts, setItemCounts] = useState(new Map());
  console.log("🚀 ~ PosLayout ~ itemCounts:", itemCounts);
  const [isQuantityChanged, setIsQuantityChanged] = React.useState(false);
  const [kotList, setKotList] = useState([]);

  const [placedItems, setPlacedItems] = useState([]);

  const toggleSidebar = () => setIsSidebarOpen((prev) => !prev);
  const closeSidebar = () => setIsSidebarOpen(false);
  const toggleOrderSummary = () => setIsMobileOrder(!isMobileOrder);
  const kotListRef = useRef();
  const [selectedNotes, setSelectedNotes] = useState([]);
  console.log("🚀 ~ PosLayout ~ selectedNotes:", selectedNotes);

  const selectedExtraData = productExtrasMap[selectedNotes?.productId];
  console.log("🚀 ~ PosLayout ~ selectedExtraData:", selectedExtraData);

  const handleAddToCart = (item) => {
    console.log("handleAddToCart ~ item:", item);

    const productId = item?.ITId ?? selectedItem?.ITId;
    if (!productId) {
      toast.error("Please select an item first.");
      return;
    }

    const updatedChildren = (selectedChildAttributes ?? []).map((child) => ({
      productId: child?.productId,
      productName: child?.productName ?? "",
      quantity: child?.quantity ?? 0,
      productPrice: child?.productPrice ?? 0,
      attributes: Array.isArray(child?.attributes)
        ? child.attributes.map((attr) => ({
            title: attr?.title,
            value: attr?.value ?? 0,
            spicyLevel: attr?.spicyLevel ?? 0,
          }))
        : [],
    }));

    const tableKey = selectedCourt?.TableKey || "temp";
    const currentOrder = orderData[tableKey] ?? {
      tableId: null,
      remarks: "",
      items: [],
    };

    // Generate unique OrderIndex (incremental based on existing items)
    const nextIndex =
      currentOrder.items.length > 0
        ? Math.max(...currentOrder.items.map((i) => i.OrderIndex)) + 1
        : 1;

    const newItem = {
      // Core identifiers
      OrderIndex: nextIndex, // ✅ use unique index
      productId,
      productName: item?.ITName ?? selectedItem?.ITName ?? "",
      productPrice: item?.SRate || 0,
      unitName: item?.MunitParticulars ?? selectedItem?.MunitParticulars ?? "",

      // Quantities
      quantity: complementary === true ? 0 : count,
      complimentaryQuantity: complementary === true ? count : 0,
      finalQuantity: count,

      // Misc
      note: notes ?? "",
      remarks: notes ?? "",
      isComplimentary: complementary,
      names: selectedCustomer?.Fname || "",
      phoneNo: selectedCustomer?.TelMobile || "",
      image: item?.ImagePath?.trim()
        ? item.ImagePath
        : selectedItem?.ImagePath?.trim()
        ? selectedItem.ImagePath
        : "https://via.placeholder.com/60",

      attributes: Object.values(selectedAttributes).map((attrGroup) => {
        const option = attrGroup.Option;
        return {
          title: option?.title,
          value: option?.value,
          spicyLevel: option?.spicyLevel ?? 0,
        };
      }),

      children: updatedChildren,
      isLocalItem: true,
    };

    console.log("handleAddToCart ~ newItem:", newItem);

    // Merge or add new
    const existingItemIndex = currentOrder.items.findIndex(
      (i) =>
        i.productId === newItem.productId &&
        JSON.stringify(i.attributes) === JSON.stringify(newItem.attributes) &&
        JSON.stringify(i.children) === JSON.stringify(newItem.children) &&
        i.isComplimentary === newItem.isComplimentary
    );

    let updatedItems;
    if (existingItemIndex >= 0) {
      const existing = currentOrder.items[existingItemIndex];
      updatedItems = [...currentOrder.items];

      updatedItems[existingItemIndex] = {
        ...existing,
        quantity: existing.quantity + newItem.quantity,
        complimentaryQuantity:
          existing.complimentaryQuantity + newItem.complimentaryQuantity,
        finalQuantity:
          existing.quantity +
          newItem.quantity +
          existing.complimentaryQuantity +
          newItem.complimentaryQuantity,
        note: newItem.note || existing.note,
        names: newItem?.names || "",
        phoneNo: newItem?.phoneNo || "",
        remarks: newItem.remarks || existing.remarks,
        isComplimentary:
          existing.complimentaryQuantity + newItem.complimentaryQuantity > 0,
        children: updatedChildren.length
          ? updatedChildren
          : existing.children ?? [],
      };
    } else {
      updatedItems = [
        ...currentOrder.items,
        {
          ...newItem,
          finalQuantity: newItem.quantity + newItem.complimentaryQuantity,
          isComplimentary: newItem.complimentaryQuantity > 0,
        },
      ];
    }

    dispatch(
      setOrderData({
        [tableKey]: {
          ...currentOrder,
          isNewItem: true,
          items: updatedItems,
        },
      })
    );

    toast.success(
      `Item added to ${tableKey === "temp" ? "temporary cart" : "table cart"} ${
        complementary ? "(Complementary)" : ""
      }.`
    );

    setSelectedItem({});
    resetModalState();
  };

  const handlePlaceOrder = async () => {
    console.log("from handle place order...");

    const rawOrder = orderData[selectedCourt?.TableKey];
    if (!rawOrder || !rawOrder.items.length) {
      toast.error("Cart is empty.");
      return;
    }

    // Only unplaced items
    const unplacedItems = rawOrder.items.filter((it) => !it.placed);
    console.log("🚀 ~ handlePlaceOrder ~ unplacedItems:", unplacedItems);
    if (!unplacedItems.length) {
      toast.error("No new items to place.");
      return;
    }

    const userData = JSON.parse(localStorage.getItem("user") || "{}");
    const userName = userData.UserName || "superuser";

    // Build orderDetailsList
    const orderDetailsList = unplacedItems.flatMap((item, index) => {
      // Use updated quantity if it exists, otherwise use the already placed quantity
      const quantity = String(
        itemCounts.hasOwnProperty(item?.OrderIndex)
          ? itemCounts[item.OrderIndex]
          : item.quantity ?? 0
      );

      const complimentaryQuantity = item.complimentaryQuantity || 0;
      const orderDetails = [];

      if (Number(quantity) > 0) {
        orderDetails.push({
          Index: index + 1,
          ItemId: item.productId,
          Quantity: quantity, // updated or existing
          IsCombo: item.children?.length > 0 || false,
          Rate: 0,
          SeatNo: 1,
          Amount: 0,
          Waiter: userName,
          StatusID: -1,
          Note: productExtrasMap[item.productId]?.note || "",
        });
      }

      if (complimentaryQuantity > 0) {
        orderDetails.push({
          Index: index + 1,
          ItemId: item.productId,
          Quantity: String(complimentaryQuantity),
          IsCombo: item.children?.length > 0 || false,
          Rate: 0,
          Note: item.note ? `${item.note} (Complementary)` : "Complementary",
          SeatNo: 1,
          Amount: 0,
          Waiter: userName,
          StatusID: -1,
        });
      }

      return orderDetails;
    });

    // Build extras for all products
    const orderExtraItem = Object.values(productExtrasMap).flatMap((product) =>
      product.extras?.map((child) => ({
        ItemID: product.productId,
        Quantity: child.qty || 0,
        ExtraItem: child.ExtraItem,
        ExtraItemID: child.ExtraItemID,
        ExtraPrice: child.ExtraPrice,
        SeatNo: 1,
      }))
    );

    const payload = {
      orderMasterInfo: {
        Address: "",
        ArchivedBy: "superuser",
        UserName: userName,
        BillNo: "",
        BillPaid: 0,
        phoneNo: selectedCustomer?.TelMobile || "",
        membershipId: -1,
        IsCancelled: false,
        IsSplit: false,
        names: selectedCustomer?.Fname || "",
        TableId: 0,
        Remarks: rawOrder.remarks || "",
        OrderTypeID: 9,
        GuestNo: 1,
        OrderMasterID: selectedCourt?.OrderMasterID || 0,
        TableKey: selectedCourt?.TableKey || "",
        TermAmount: 0,
        orderDetailsList,
      },
      orderExtraItem,
      foodCourtOrder: false,
    };

    console.log("Payload sent to backend:", payload);

    try {
      setLoading(true);
      const response = await RestroOrderService.order(payload);
      if (!response?.d) throw new Error("Invalid order response from backend.");

      // Clear local cart for this table
      const cartOrders = JSON.parse(localStorage.getItem("cartOrders") || "{}");
      if (cartOrders[selectedCourt?.TableKey]) {
        delete cartOrders[selectedCourt?.TableKey];
        localStorage.setItem("cartOrders", JSON.stringify(cartOrders));
      }

      dispatch(resetTableOrder(selectedCourt?.TableKey));

      toast.success("Order created successfully.");
      localStorage.removeItem("selectedCustomer");
      fetchOrder();
      fetchSection();
      resetModalState();
    } catch (error) {
      console.error("Error placing order:", error);
      toast.error("Failed to place order.");
    } finally {
      setLoading(false);
    }
  };

  const fetchOrder = async () => {
    setLoading(true);
    setError(null);

    try {
      const jsonData = await RestroOrderService.getPreviousOrder({
        tableKey: selectedCourt?.TableKey,
      });
      console.log("🚀 ~ fetchOrder ~ jsonData:", jsonData);

      // Map placed items from backend
      const placedMapped = jsonData?.OrderItem?.map((item) => {
        const amount = (item.Rate || 0) * (item.Quantity || 0);
        const isAllComp = amount === 0 && item.Quantity > 0 && item.Rate === 0;

        return {
          id: item.OrderDetailID || 0, // optional, may not exist
          productId: item.ItemId,
          quantity: isAllComp ? 0 : item.Quantity,
          complimentaryQuantity: isAllComp ? item.Quantity : 0,
          finalQuantity: item.Quantity,
          remarks: item.Note || "",
          isComplimentary: isAllComp,
          attributes: [],
          productName: item?.ItemName || item?.ITName,
          productPrice: item.Rate || 0,
          image: item.ImagePath || "https://via.placeholder.com/60",
          orderItemStatus: item.ItemStatus || "Pending",
          printingRemainingQuantity: item.Quantity - (item.PrintCount || 0),
          printedQuantity: item.PrintCount || 0,
          orderNo: jsonData.OrderDetail?.[0]?.OrderNo,
          orderMasterId: jsonData.OrderDetail?.[0]?.OrderMasterId || null,
          OrderIndex: item?.OrderIndex,

          children: [],
        };
      });

      // Merge with local unplaced items
      const cartOrders = JSON.parse(localStorage.getItem("cartOrders") || "{}");
      const localItems =
        cartOrders[selectedCourt?.tableKey]?.items?.filter(
          (i) => typeof i.id === "undefined"
        ) || [];

      const mergedItems =
        localItems.length > 0 ? [...placedMapped, ...localItems] : placedMapped;

      // Build order summary
      const master = jsonData.OrderDetail?.[0] || {};
      const calculatedTotal = placedMapped.reduce(
        (acc, item) => acc + item.productPrice * item.finalQuantity,
        0
      );

      const mappedOrder = {
        orderNo: master?.OrderNo,
        orderId: master?.OrderMasterId || 0,
        tableId: 0,
        TableKey: selectedCourt?.TableKey || "",
        orderRefrenceId: master?.BillNo || "",
        totalAmount: calculatedTotal,
        discountAmount: master?.totaldiscount || 0,
        taxAmount: 0,
        grandTotal: calculatedTotal - (master?.totaldiscount || 0),
        paymentStatus: master?.IsBillPaid ? "Paid" : "Pending",
        orderStatus: master?.IsCancelled ? "Cancelled" : "Active",
        remarks: "",
        items: mergedItems,
      };
      console.log("🚀 ~ fetchOrder ~ mappedOrder:", mappedOrder);

      // Update Redux only (no localStorage writes)
      dispatch(
        setApiOrderData({
          [selectedCourt?.TableKey]: mappedOrder,
        })
      );
    } catch (error) {
      console.error("Error fetching orders:", error);
      setError("Failed to fetch order.");
    } finally {
      setLoading(false);
    }
  };

  const fetchSection = async () => {
    try {
      const data = await RestroOrderService.getFoodCourt();
      console.log("✅ Parsed JSON:", data);
      setSectionData(data);
    } catch (error) {
      console.error("Error fetching section data:", error);
    }
  };

  const fetchTable = async () => {
    setLoading(true);
    try {
      const response = await RestroOrderService.getTable({
        RoomId: selectedSection?.value, // <-- wrap in object
      });
      console.log("🚀 ~ fetchTable ~ response:", response);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTable();
  }, [selectedSection?.value]);

  const resetModalState = () => {
    setIsModalOpen(false);
    setComplementary(false);
    setCount(1);
    setSelectedAttributes([]);
    setNotes("");
  };

  useEffect(() => {
    if (selectedCourt?.TableKey) {
      // 🔥 FIX: Clear previous table data to prevent mixing
      dispatch(resetTableOrder(selectedCourt.TableKey));

      // Reload fresh data
      fetchOrder();
    }
  }, [selectedCourt?.TableKey]);

  useEffect(() => {
    fetchSection();
  }, []);

  const [isRefreshing, setIsRefreshing] = useState(false);

  const handleRefresh = async () => {
    try {
      setIsRefreshing(true);

      await Promise.all([fetchOrder(), fetchSection(), fetchTable()]);

      toast.success("Refresh successful.");
    } catch (error) {
      toast.error("Failed to refresh");
    } finally {
      setIsRefreshing(false);
    }
  };

  return (
    <div className="container-xxl " style={{ height: "100vh" }}>
      <Row>
        <Col
          md={7}
          lg={8}
          className=" d-flex flex-column"
          style={{
            height: "100vh",
          }}
        >
          <div className="sticky-top ">
            <SecondaryHeader
              toggleSidebar={toggleSidebar}
              sectionData={sectionData}
              setSelectedSection={setSelectedSection}
              selectedSection={selectedSection}
              data={data}
              kotListRef={kotListRef}
              setIsTableOpen={setIsTableOpen}
              isTableOpen={isTableOpen}
              kotList={kotList}
              setKotList={setKotList}
              handleRefresh={handleRefresh}
              isRefreshing={isRefreshing}
              setSelectedCourt={setSelectedCourt}
              fetchTable={fetchTable}
              fetchSection={fetchSection}
            />
            {/* Optionally hide sidebar below md */}
            <div className="d-none d-md-block">
              <Sidebar isOpen={isSidebarOpen} closeSidebar={closeSidebar} />
            </div>
          </div>
          {/* Product Page Scrolls */}
          <div className="flex-grow-1 overflow-y-auto overflow-x-hidden ">
            <ProductPage
              setSelectedItem={setSelectedItem}
              selectedItem={selectedItem}
              setCount={setCount}
              setComplimentaryCount={setComplimentaryCount}
              count={count}
              setSelectedAttributes={setSelectedAttributes}
              selectedAttributes={selectedAttributes}
              handleAddToCart={handleAddToCart}
              setNotes={setNotes}
              notes={notes}
              isModalOpen={isModalOpen}
              setIsModalOpen={setIsModalOpen}
              setComplementary={setComplementary}
              complementary={complementary}
              loading={loading}
              toggleOrderSummary={toggleOrderSummary}
              orderData={orderData}
              setSelectedChildAttributes={setSelectedChildAttributes}
              selectedChildAttributes={selectedChildAttributes}
              selectedCourt={selectedCourt}
              fetchTable={fetchTable}
            />
          </div>
        </Col>

        <Col
          md={5}
          lg={4}
          className="pt-lg-2 pt-md-2 d-none d-lg-block d-md-block"
          style={{
            height: "100vh",
          }}
        >
          <OrderSummary
            orderData={orderData}
            setOrderId={setOrderId}
            orderId={orderId}
            data={data}
            fetchTable={fetchTable}
            sectionData={sectionData}
            setSelectedSection={setSelectedSection}
            selectedSection={selectedSection}
            fetchOrder={fetchOrder}
            handlePlaceOrder={handlePlaceOrder}
            billData={billsData}
            itemCounts={itemCounts}
            setItemCounts={setItemCounts}
            setIsQuantityChanged={setIsQuantityChanged}
            isQuantityChanged={isQuantityChanged}
            placedLoading={loading}
            placedItems={placedItems}
            handleRefresh={handleRefresh}
            setSelectedCourt={setSelectedCourt}
            selectedCourt={selectedCourt}
            fetchSection={fetchSection}
          />
        </Col>
      </Row>
      {isMobileOrder && (
        <OrderSummaryModal
          isOpen={isMobileOrder}
          toggle={toggleOrderSummary}
          // setOrderData={setOrderData}
          orderData={orderData}
          setOrderId={setOrderId}
          orderId={orderId}
          data={data}
          fetchTable={fetchTable}
          sectionData={sectionData}
          setSelectedSection={setSelectedSection}
          selectedSection={selectedSection}
          fetchOrder={fetchOrder}
          handlePlaceOrder={handlePlaceOrder}
          itemCounts={itemCounts}
          setItemCounts={setItemCounts}
          setIsQuantityChanged={setIsQuantityChanged}
          isQuantityChanged={isQuantityChanged}
          placedLoading={loading}
          placedItems={placedItems}
          handleRefresh={handleRefresh}
          isRefreshing={isRefreshing}
          fetchSection={fetchSection}
          setSelectedCourt={setSelectedCourt}
          selectedCourt={selectedCourt}
          setRecentCustomers={setRecentCustomers}
          recentCustomers={recentCustomers}
          productExtrasMap={productExtrasMap}
          setProductExtrasMap={setProductExtrasMap}
          setSelectedNotes={setSelectedNotes}
          selectedNotes={selectedNotes}
        />
      )}
    </div>
  );
};

export default PosLayout;
